// extracted by mini-css-extract-plugin
export default {"applyMargin":"ProjectCriteriaFilter_applyMargin_lNfg4","dropdownItem":"ProjectCriteriaFilter_dropdownItem_jjjF0","spinAround":"ProjectCriteriaFilter_spinAround_D2U79"};